
import * as React from 'react'
import { NavDropdown } from 'react-bootstrap'
import ItemMenu from '../../interfaces/Catalogos/IItemMenu'

interface ISubmenuProps {
  submenu: ItemMenu[]
  descripcion: string
  allItems: ItemMenu[]
}

const Submenu: React.FunctionComponent<ISubmenuProps> = (props) => {
  const esPadre = (ItemSubmenu: ItemMenu, allItems: ItemMenu[]) => {
    var arrHijos = allItems.filter((item) => ItemSubmenu.id === item.padreId)
    return arrHijos.length > 0
  }

  
  const styles = `
    .menu-hybrid {
      font-family: 'Segoe UI', sans-serif;
      /* El "Azulito" que te gustó */
      --electric-blue: #00c6ff; 
      --deep-blue: #0072ff;
    }

    /* 1. BOTÓN PRINCIPAL (Navbar) */
    .menu-hybrid > .nav-item > .nav-link {
      color: rgba(255,255,255,0.9) !important;
      font-weight: 600;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;
    }
    /* Hover del principal */
    .menu-hybrid > .nav-item > .nav-link:hover,
    .menu-hybrid > .nav-item.show > .nav-link {
      color: #fff !important;
      text-shadow: 0 0 10px rgba(0, 198, 255, 0.7); /* Brillo azulito */
    }

    /* 2. CAJA DEL MENÚ (Fondo Blanco Limpio) */
    .menu-hybrid .dropdown-menu {
      background: #ffffff !important;
      border: none;
      border-radius: 0 12px 0 12px; /* Esquinas modernas */
      padding: 8px 0;
      margin-top: 10px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); /* Sombra elegante */
      min-width: 240px;
      animation: slideIn 0.2s ease-out forwards;
    }

    /* 3. ÍTEMS (Opciones) */
    .menu-hybrid .dropdown-item {
      color: #555 !important; /* Gris oscuro normal */
      padding: 12px 20px;
      font-weight: 500;
      border-left: 3px solid transparent; /* Línea invisible lista para aparecer */
      transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      position: relative;
    }

    
    .menu-hybrid .dropdown-item:hover,
    .menu-hybrid .dropdown-item:focus {
      /* El degradado azulito sutil sobre fondo blanco */
      background: linear-gradient(90deg, rgba(0, 198, 255, 0.12) 0%, transparent 100%) !important;
      
      /* Texto azul eléctrico brillante */
      color: var(--deep-blue) !important;
      
      /* La barrita neón a la izquierda */
      border-left: 4px solid var(--electric-blue);
      
      /* El movimiento a la derecha */
      padding-left: 28px; 
      
      /* Un poco de brillo en el texto */
      text-shadow: 0 0 1px rgba(0, 114, 255, 0.3);
      font-weight: 600;
    }

    /* Submenú Anidado (Nivel 2) */
    .menu-hybrid #secondlevel + .dropdown-menu {
      top: -5px !important;
      left: 100%;
      margin-left: 5px;
      border-left: 2px solid var(--electric-blue); /* Borde azulito de separación */
    }

    /* Flechita personalizada */
    .menu-hybrid .dropdown-toggle#secondlevel::after {
      content: '›'; 
      float: right;
      border: none;
      color: #ccc;
      font-size: 1.4em;
      line-height: 0.8;
      transition: all 0.3s;
    }
    .menu-hybrid .dropdown-toggle#secondlevel:hover::after {
      color: var(--electric-blue);
      transform: translateX(3px);
    }

    @keyframes slideIn {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `

  return (
    <div className="menu-hybrid">
      <style>{styles}</style>
      <NavDropdown title={props.descripcion} id="basic-nav-dropdown">
        {props.submenu.map((item) => {
          if (!esPadre(item, props.allItems)) {
            return (
              <NavDropdown.Item key={item.id} href={'/#/' + item.url}>
                {item.descripcion}
              </NavDropdown.Item>
            )
          } else {
            return (
              <NavDropdown
                key={item.id}
                title={item.descripcion}
                id="secondlevel"
                drop="end"
                className="submenu-trigger"
              >
                {props.allItems
                  .filter((row) => row.padreId === item.id)
                  .map((row) => (
                    <NavDropdown.Item key={row.id} href={'/#/' + row.url}>
                      {row.descripcion}
                    </NavDropdown.Item>
                  ))}
              </NavDropdown>
            )
          }
        })}
      </NavDropdown>
    </div>
  )
}

export default Submenu